import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api";
import { Search } from "lucide-react";

export default function PlayerSearch() {
  const [q, setQ] = useState(""); const [results, setResults] = useState([]); const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!q.trim()) { setResults([]); return; }
    const t = setTimeout(() => api.get("/users/search", { params: { q } }).then(r => setResults(r.data.users)).catch(()=>{}), 200);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  return (
    <div ref={ref} className="relative" data-testid="player-search">
      <div className="relative">
        <Search className="absolute left-3 top-2.5 w-4 h-4 text-gray-400 pointer-events-none"/>
        <input data-testid="player-search-input" value={q} onChange={e => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
          placeholder="Find player…" className="rounded-2xl pl-9 pr-3 py-2 w-48 bg-white shadow-cartoon-sm border-2 border-[#2a1f3d]/10 focus:outline-none focus:border-[#ff6fa3] text-sm"/>
      </div>
      {open && results.length > 0 && (
        <div className="absolute top-full mt-2 right-0 w-72 card-cartoon p-2 z-50 max-h-72 overflow-auto">
          {results.map(u => (
            <Link key={u.id} to={`/profile/${u.roblox_username_lc}`} onClick={() => { setOpen(false); setQ(""); }} data-testid={`search-result-${u.roblox_username_lc}`}
              className="flex items-center gap-2 p-2 rounded-xl hover:bg-[#ffd1e8]/40 btn-pop">
              {u.avatar_url && <img src={u.avatar_url} alt="" className="w-8 h-8 rounded-full"/>}
              <div className="flex-1 min-w-0">
                <div className="font-bold truncate">{u.roblox_username}</div>
                <div className="text-xs text-[#7649e6]">Rep {u.reputation || 0} • {u.role}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
